import axios from "axios";
import Dictionary from "@/types/Dictionary";
import { API_URL } from "@/App.settings";
import { ConnexionPageState } from "../ConnexionPageState";
import { ConnexionPageSendMail } from "./ConnexionPageSendMail";
import { ConnexionPageInitial } from "./ConnexionPageInitial";
import { ConnexionPageWeakPassword } from "./ConnexionPageWeakPassword";

/** Etat de gestion d'un oublie de mot de passe */
export class ConnexionPageResetPassword extends ConnexionPageState{

    /** Envoi un mail de réinitialisation de mot de passe à l'utilisateur puis affiche le message de validation d'envoie de l'e-mail */
    public async SendMail(): Promise<void> {
        /** Initialise un 'dumy' mail */
        this.context.Email = "******@****.***"

        /** Affiche l'overlay de chargement  */
        this.context.Vue.$store.dispatch("ShowLoadingMask", this.context.Vue.$t('LoginInProgress'));     // "Identification en cours"

        /** Paramètres de l'envoi du mail */
        const args: Dictionary<any> = {
            Login: this.context.LoginForgotPassword,
            FrontUrl: new URL(this.context.Vue.$router.resolve('Registration').href, window.location.origin), /** URL de la page d'inscription */
        };

        /** Envoie du mail de réinitialisation */
        await axios({ method: 'POST', url: API_URL + "connexion/getForgotPassword", data: args, headers: {'Content-Type': 'application/json' }
        }).then((response) => {
            
            this.context.Email = this.obfuscateEmail(response.data);
        })
        .finally(() => {
            /** Stope l'overlay de chargement */
            this.context.Vue.$store.dispatch("HideLoadingMask", {});

            /** Retire l'affichage du formulaire. */
            this.context.ShowResetPasswordForm = false;
            /** Affiche la confirmation de l'envoi du mail. */
            this.context.ShowMailSend = true;

            /** Changement de context */
            this.context.State = new ConnexionPageSendMail(this.context);
        });
    }

    /** 
     * Offusce visuelement un email
     * @param email : Email à offuscer
     */
    private obfuscateEmail(email: string): string {
        /** Décompose l'email entre domaine et utilisateur */
        const [local, domain] = email.split('@');

        /** Masquer le local (avant le @) */
        const visibleLocal = local.slice(0, 2);
        const hiddenLocal = '*'.repeat(Math.max(0, local.length - 2));

        /** Masquer le domaine (après le @) */
        const domainParts = domain.split('.');
        const visibleDomain = domainParts[0].slice(0, 1) + '***';
        const remainingDomain = domainParts.slice(1).join('.');

        return `${visibleLocal}${hiddenLocal}@${visibleDomain}.${remainingDomain}`;
    }

    /** 
     * Annule la demande de changement de mot de passe
     *  - Si l'utilisateur est authentifié alors nous affichons l'avertissement de sécurité
     *  - Si l'utilisateur n'est pas authentifié
     */
    public async Abord(): Promise<void> {
        if(this.context.SignInResult){
            /** Utilisateur authentifié -> go page d'avertissement de sécurité sur la police de sécurité des mots de passe*/
            this.context.ShowPasswordForm = true;
            this.context.ShowWeakPasswordPolicy = true;
            this.context.State = new ConnexionPageWeakPassword(this.context);
        } else {
            /** Utilisateur non authentifié -> retour page de connexion*/
            this.context.ShowLoginForm = true;
            this.context.State = new ConnexionPageInitial(this.context);
        }
        this.context.ShowResetPasswordForm = false;
    }

    //#region CAS INGORE
    /** VOID */
    public async SignIn(): Promise<void> { /** Impossible de s'authentifier en */ }

    /** VOID */
    public ResetPassword(): void { /** Impossible car cyclique */ }

    /** VOID */
    public About(): void { /** Non proposé à l'utilisateur */ }
    //#endregion CAS INGORE
}